import {layout, ScrollableCard} from 'mc/lib';
import React, {Component} from 'react';
import {connect} from "react-redux";

class RegistracePage extends Component {

    render() {
        return (
            <div className="app-wrapper">
                <div className="app-wrapper-content">
                    <layout.PageWrapper>
                        <layout.PageContent fullWidth>
                            <ScrollableCard detail className="registrace-success">
                                <h1>Žádost o registraci</h1>
                                <p>Registrace proběhla úspěšně. Na zadanou e-mailovou adresu byly odeslány informace pro aktivaci přístupu ke Stránkám uživatele.</p>
                                <p>Kartu prohlížeče můžete uzavřít.</p>
                            </ScrollableCard>
                        </layout.PageContent>
                    </layout.PageWrapper>
                </div>
            </div>
        );
    }
}

export default connect()(RegistracePage);
